export { AgentAttributions } from './AgentAttributions';
export {
    recommendedAgentsKeys,
    useAgentAttributionsEnabled,
    useAutomationsTabShown,
} from './api/use-recommended-agents';
export { ProfileAutomationsTabs } from './ProfileAutomationsTabs';
export { ItemRecommendedAgents, PositionRecommendedAgents } from './RecommendedAgents';
export { agentsRoute } from './route';
export type { AgentAttributionsTilePayload } from './url-tile';
export {
    AGENT_ATTRIBUTIONS_TILE_TYPE,
    agentsUrlTileModule,
    createAgentAttributionsTilePayload,
} from './url-tile';

export const loadAgentsLibraryPage = async () => {
    const { AgentsLibraryPage } = await import('./library/AgentsLibraryPage');

    return { Component: AgentsLibraryPage };
};
